import { CCard, CCardBody, CRow, CCol, CFormSelect, CLoadingButton } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilSend, cilPeople } from '@coreui/icons'
import React, { useEffect, useState } from 'react'
import ClubService from 'src/service/ClubService'
import MemberInviteUserList from './MemberInviteUserList'
import ToastComponent from 'src/components/common/TaostComponent'

// "Previous Members" tab of the Invitation step: pick a previous game, then select and invite
// its members to this one. Same underlying flow as before, redesigned to match the current UI.
const MemberInvites = () => {
  const [loading, setLoading] = useState(false)
  const [gameId, setGameId] = useState('')
  const [gameList, setGameList] = useState([])
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([])
  const [sending, setSending] = useState(false)
  const [reloadToken, setReloadToken] = useState(0)

  useEffect(() => {
    setLoading(true)
    ClubService.getGames()
      .then((res) => {
        if (res.status === 200) setGameList(res.data)
      })
      .finally(() => setLoading(false))
  }, [])

  const handleGameChange = (e) => {
    setGameId(e.target.value)
    setSelectedCheckboxes([])
  }

  const sendAllInvitaitonSelectedUser = () => {
    if (selectedCheckboxes.length <= 0) {
      ToastComponent('Please select at least one member.', 'error')
      return
    }
    setSending(true)
    ClubService.sendMemberInvite({ userIds: selectedCheckboxes, gameId })
      .then((res) => {
        if (res.status === 200) {
          ToastComponent(res.message, 'success')
          setSelectedCheckboxes([])
          setReloadToken((t) => t + 1)
        } else {
          ToastComponent(res.message || 'Could not send invites.', 'error')
        }
      })
      .catch(() => ToastComponent('Could not send invites. Please try again.', 'error'))
      .finally(() => setSending(false))
  }

  return (
    <CCard className="border-secondary-subtle rounded-4">
      <CCardBody>
        <div className="fw-semibold fs-6 mb-1">Select Previous Game</div>
        <div className="small mb-3">Choose a previous game to invite members who played in it.</div>
        <CRow className="mb-4">
          <CCol md={5}>
            <CFormSelect
              aria-label="Select Game"
              value={gameId}
              onChange={handleGameChange}
              disabled={loading}
            >
              <option value="">Select a game&hellip;</option>
              {gameList.map((item) => (
                <option value={item?.id} key={item?.id}>
                  {item?.game_name}
                </option>
              ))}
            </CFormSelect>
          </CCol>
        </CRow>

        {gameId ? (
          <MemberInviteUserList
            gameId={gameId}
            reloadToken={reloadToken}
            selectedCheckboxes={selectedCheckboxes}
            setSelectedCheckboxes={setSelectedCheckboxes}
            footerTrailing={
              <CLoadingButton
                color="success"
                loading={sending}
                disabled={!selectedCheckboxes.length}
                onClick={sendAllInvitaitonSelectedUser}
              >
                <CIcon icon={cilSend} className="me-1" />
                Send Invites
              </CLoadingButton>
            }
          />
        ) : (
          <div className="text-center py-5 text-medium-emphasis">
            <CIcon icon={cilPeople} size="xl" className="mb-2" />
            <div>Select a previous game above to see its members.</div>
          </div>
        )}
      </CCardBody>
    </CCard>
  )
}

export default MemberInvites
